import React from 'react';
import Navlink from './nav-links/navlink';
import Social from '../common/social/social';
import SubFooter from '../common/sub-footer/sub-footer';
import { IFooterProps } from '../IFooter';
import QuickLink from '../../../basic/quickLink';
import Image from '../../../basic/image';
import { DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../../../basic/analytics';
import { useContent } from '../../../../providers/content/hook';

const DesktopFooter = ({ footerProps, className }: IFooterProps): JSX.Element => {
  const { mainNavigation, social, disclaimer, subFooter, siteFooterlogo, bottomNavigationLinks } = footerProps || {};
  const { content } = useContent();
  return (
    <div className={className} data-testid="footer-section" role="contentinfo">
      <div className="bg-[#003b71] container-none py-16 px-5 flex justify-center">
        <div className="container flex flex-row mx-2xl gap-3 space-around">
          {mainNavigation && <Navlink navlinks={mainNavigation} disclaimer={disclaimer} />}
        </div>
      </div>
      <div className="container-none bg-secondary-500 px-5 flex justify-center bg-[#0d1c3d]">
        <div className="container flex flex-col mx-2xl text-white py-10">
          {siteFooterlogo && siteFooterlogo.url && (
            <div className='flex items-center w-[220px] h-auto justify-center'>
              <QuickLink href="/" aria-label={content?.header?.alternate_text} dataAnalytics={buildAnalytics(DataAnalyticsLocations.Footer, DataAnalyticsTypes.Media)}>
                <Image alt={content?.header?.alternate_text} src={siteFooterlogo.url} layout="responsive" />
              </QuickLink>
            </div>
          )}
          <div className="pt-8">
            {bottomNavigationLinks && <Navlink navlinks={bottomNavigationLinks} disclaimer={disclaimer} section="bottom" />}
          </div>
          <div className="pt-4">
            {social && <Social socialItems={social} disclaimer={disclaimer} />}
          </div>  
          <div className="container flex flex-row">
            <SubFooter items={subFooter} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopFooter;
